module.exports = __webpack_public_path__ + "img/撩ta (2).4f17241a.png";